import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, Button, message } from "antd";
import Service from "../../../services/staff";

const StaffForm = ({ visible, onClose, staffId, onSuccess }) => {
  const isEdit = !!staffId;
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    isActive: false
  });

  useEffect(() => {
    if (visible && isEdit) {
      loadStaff();
    }
    if (visible && !isEdit) {
      resetForm();
    }
  }, [visible, staffId]);

  const resetForm = () => {
    setForm({
      firstName: "",
      lastName: "",
      email: "",
      isActive: false
    });
  };

  const loadStaff = async () => {
    try {
      const data = await Service.getStaffDetails(staffId);
      setForm({ ...data });
    } catch {
      message.error("Failed to load staff details");
    }
  };

  const onSubmit = async () => {
    setLoading(true);
    try {
      if (isEdit) {
        await Service.updateStaff(staffId, form);
        message.success("Staff updated");
      } else {
        await Service.createStaff({
          firstName: form.firstName,
          lastName: form.lastName,
          email: form.email
        });
        message.success("Staff created. Invitation email sent.");
      }
      onSuccess();
      onClose();
    } catch {
      message.error("Operation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      visible={visible}
      title={isEdit ? "Edit Staff" : "Add Staff"}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form layout="vertical">
        <Form.Item label="First Name" required>
          <Input
            value={form.firstName}
            onChange={e => setForm({ ...form, firstName: e.target.value })}
          />
        </Form.Item>

        <Form.Item label="Last Name" required>
          <Input
            value={form.lastName}
            onChange={e => setForm({ ...form, lastName: e.target.value })}
          />
        </Form.Item>

        <Form.Item label="Email" required>
          <Input
            value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })}
            disabled={isEdit}
          />
        </Form.Item>

        {isEdit && (
          <Form.Item label="Status">
            <Select
              value={form.isActive}
              onChange={v => setForm({ ...form, isActive: v })}
            >
              <Select.Option value={true}>Active</Select.Option>
              <Select.Option value={false}>Inactive</Select.Option>
            </Select>
          </Form.Item>
        )}

        <div style={{ textAlign: "right" }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" loading={loading} onClick={onSubmit}>
            {isEdit ? "Save" : "Send Invitation"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default StaffForm;
